import React from 'react'
import {
    Text,
    View,
    Image,
    TouchableOpacity,
    ScrollView,
    ActivityIndicator
} from 'react-native'
import moment from 'moment'
import styles from './styles'
import {
    weeklyPeriodFormat,
    weeklyPeriod,
    prepWeeklyReport,
    currencyFormat
} from '../../lib/index'
import Listings from '../../components/listings/index'

export const WeeklyRanges = (props) => {
    const { onPress, onClose } = props

    const  today = moment().format('L')
    var periods = []
    for (let i=0; i<51; i++) {
        periods[i] = weeklyPeriod(today, i)
    }

    return (
        <View style={styles.container}>
            <View style={styles.headerView}>
                <Text style={styles.header}>
                    Historical Statements
                </Text>

                <View style={styles.hr} />

                <Text style={styles.subheader}>
                    Click To View Statement Details
                </Text>
            </View>

            <TouchableOpacity
                style={styles.close}
                activeOpacity={0.8}
                onPress={onClose.bind(this)}>
                    <Text style={styles.closeText}>X</Text>
            </TouchableOpacity>

            <View style={styles.weeklyView}>
                <ScrollView
                    contentContainerStyle={{ alignItems: 'center' }}
                    horizontal={false}>

                    {periods.map((period, idx) => {
                        return (
                            <TouchableOpacity
                                key={idx}
                                activeOpacity={0.8}
                                style={styles.weeklyViewPeriod}
                                onPress={onPress.bind(this, period)}>

                                <Text style={styles.weeklyText}>
                                    {weeklyPeriodFormat(period)}
                                </Text>

                            </TouchableOpacity>
                        )
                    })}
                </ScrollView>
            </View>
        </View>
    )
}

export const WeeklyTotals = (props) => {
    const { isWeeklyLoading, noWeeklyTransactions, transactions, period, onBack, onClose } = props

    let data = {
        aggregation: {
            revenue: 0,
            cashback: 0,
            marketing: 0,
            total: 0
        },
        customers: 0
    }

    if (transactions) data = prepWeeklyReport(transactions)

    return (
        <View style={styles.container}>
            <View style={styles.headerView}>
                <Text style={styles.header}>
                    {weeklyPeriodFormat(period)}
                </Text>
                <View style={styles.hr} />
            </View>

            <TouchableOpacity
                style={styles.back}
                activeOpacity={0.8}
                onPress={onBack.bind(this)}>
                    <Image style={{ width: 18, height: 14 }}
                            source={require('../../images/backIcon.png')} />
            </TouchableOpacity>

            <TouchableOpacity
                style={styles.close}
                activeOpacity={0.8}
                onPress={onClose.bind(this)}>
                    <Text style={styles.closeText}>X</Text>
            </TouchableOpacity>

            <View style={{ flex: 5, alignSelf: 'stretch'}}>
                {(isWeeklyLoading) &&
                    <ActivityIndicator size={'large'}
                        color={'#FF009B'}
                        style={{ justifyContent: 'center', alignItems: 'center' }}/>
                    }

                {noWeeklyTransactions &&
                    !isWeeklyLoading &&
                    <View style={{ justifyContent: 'center', alignItems: 'center', alignSelf: 'stretch' }}>
                        <Text style={styles.subheader}>
                            No transactions were found for the week
                        </Text>
                    </View>}

                {transactions &&
                    !noWeeklyTransactions &&
                    !isWeeklyLoading && <ScrollView
                        contentContainerStyle={{ alignItems: 'center', paddingRight: 10}}
                        horizontal={false}>

                        <View style={{ alignSelf: 'stretch' }}>
                            <View style={styles.rows1}>
                                <Text style={styles.rowValueTxt}>{currencyFormat(data.aggregation.total)}</Text>
                                <Text style={styles.rowTotalTxt}>Statement Total</Text>
                            </View>
                            <View style={styles.rows2}>
                                <View style={styles.column1}>
                                    <Text style={styles.rowValueTxt}>{currencyFormat(data.aggregation.cashback)}</Text>
                                    <Text style={styles.rowTotalTxt}>Cashback Total</Text>
                                </View>
                                <View style={styles.column2}>
                                    <Text style={styles.rowValueTxt}>{currencyFormat(data.aggregation.marketing)}</Text>
                                    <Text style={styles.rowTotalTxt}>Marketing Fee Total</Text>
                                </View>
                            </View>
                            <View style={styles.rows2}>
                                <View style={styles.column1}>
                                    <Text style={styles.rowValueTxt}>{currencyFormat(data.aggregation.revenue)}</Text>
                                    <Text style={styles.rowTotalTxt}>Total Revenue</Text>
                                </View>
                                <View style={styles.column2}>
                                    <Text style={[styles.rowValueTxt, { color: '#808080' }]}>{data.customers}</Text>
                                    <Text style={styles.rowTotalTxt}>Total Customer</Text>
                                </View>
                            </View>
                        </View>

                        <View style={{
                            marginTop: 20,
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            alignSelf: 'stretch'
                        }}>
                            <View style={styles.byline}>
                                <Text style={styles.bylineTxt}>
                                    Transactions
                                </Text>

                                <View style={{ flexDirection: 'column'}}>
                                    <View style={{ flexDirection: 'row'}}>
                                        <View style={styles.dotNew} />
                                        <Text style={styles.byline2Txt}>
                                            New Customers
                                        </Text>
                                    </View>
                                    <View style={{ flexDirection: 'row'}}>
                                        <View style={styles.dotRecurring} />
                                        <Text style={styles.byline2Txt}>
                                            Recurring Customers
                                        </Text>
                                    </View>
                                </View>
                            </View>

                            <View>
                                <Text style={styles.bylineTxt}>
                                    Cashback &amp; Fees
                                </Text>
                            </View>
                        </View>

                        <View style={{ alignSelf: 'stretch' }}>
                            <Listings
                                transactions={transactions}
                                styleSize1={{ fontSize: 14 }}
                                styleSize2={{ fontSize: 12 }} />
                        </View>
                    </ScrollView>}
            </View>
        </View>
    )
}





// WEBPACK FOOTER //
// ./src/components/weekly/index.js